import http from "./httpService";
interface BrandType {
  id?: number;
  categoryIds?: number[];
  text?: string;
}
export function getBrandData({ id, text, categoryIds }: BrandType) {
  return http
    .post("/BrandApi/GetBrandsTreeView", { id, text, categoryIds })
    .then(({ data }) => data);
}
